export enum NotificationEventName {
    NOTIFICATION_UPDATED_EVENT = 'notification-updated-event'
}

export interface NotificationEvent<Type> {
    name: NotificationEventName;
    payload: Type;
}
